import { Component, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

import { AnalyticsService } from './security/services/analytics.service';

declare let OneTrust: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  private analyticsService = inject(AnalyticsService);
  private router = inject(Router);

  showHeaderFooter = true;
  contactUsLink =
    'https://clarivate.com/intellectual-property/compumark/contact/';

  constructor() {
    if (!this.isAccessDenied()) {
      this.analyticsService.init();
    }

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.showHeaderFooter = !event.url.includes(
          'order-management/watch-alert',
        );
      });
  }

  public isAccessDenied(): boolean {
    return window.location.href.indexOf('access-denied') !== -1;
  }
  public openOneTrustModal(): void {
    OneTrust.ToggleInfoDisplay();
  }
}
